"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Input = Input;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function Input(props) {
  return /*#__PURE__*/_react["default"].createElement("input", {
    autoComplete: props.autoComplete,
    className: props.className,
    disabled: props.disabled,
    id: props.id,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    onChange: props.onChange,
    name: props.name,
    placeholder: props.placeholder,
    type: props.type,
    value: props.value,
    ref: props.getRef,
    readOnly: props.readOnly,
    checked: props.checked
  });
}

Input.propTypes = {
  autoComplete: _propTypes["default"].string,
  checked: _propTypes["default"].bool,

  /** The value for the input box content */
  value: _propTypes["default"].string,

  /** Function will be called with the ref of the final <input> element */
  getRef: _propTypes["default"].func,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  name: _propTypes["default"].string,
  type: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool
};
var _default = Input;
exports["default"] = _default;